module.exports = __webpack_public_path__ + "media/images/pages/bg_area_14-9e55bad880374ebe2bc099e0bad877b1.png";